import { Injectable } from '@angular/core';
import { SetupService } from '../setup/setup.service';

@Injectable()
export class EndpointService {

  constructor(private setup: SetupService) { }

  get authenticationCheckUrl(): string {
    return this.getBaseUrl() + '/Auth/IsAuth';
  }

  get authenticationInvalidateUrl(): string {
    return this.getBaseUrl() + '/Logout.aspx';
  }

  get loadUserValueUrl(): string {
    return this.getBaseUrl() + '/User/Load';
  }

  get saveUserValueUrl(): string {
    return this.getBaseUrl() + '/User/Save';
  }

  get clearUserUrl(): string {
    return this.getBaseUrl() + '/User/Clear';
  }

  get configurationUrl(): string {
    return this.getBaseUrl() + '/Configuration';
  }

  get comboValuesUrl(): string {
    return this.getBaseUrl() + '/Data/GetComboValues';
  }

  get dataGridUrl(): string {
    return this.getBaseUrl() + '/Data';
  }

  get saveDataUrl(): string {
    return this.getBaseUrl() + '/Data/Save';
  }

  get dictionaryValueUrl(): string {
    return this.getBaseUrl() + '/Data/GetComboItemName';
  }

  get loadViewUrl(): string {
    return this.getBaseUrl() + '/Data/LoadSingleFeature';
  }

  get downloadFileUrl(): string {
    return this.getBaseUrl() + '/Data/Download';
  }

  get executeAssemblyActionUrl(): string {
    return this.getBaseUrl() + '/CustomFunction/ExecuteAction';
  }

  get executeParameterizedActionUrl(): string {
    return this.getBaseUrl() + '/CustomFunction/ExecuteParameterAction';
  }
  get notificationCountUrl(): string {
    return this.getBaseUrl() + '/Data/LoadSql';
  }

  private getBaseUrl(): string {
    return this.setup.baseUrl;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/endpoint/endpoint.service.ts